import React, { useCallback, useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'

import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import { SocketContext } from '../../context/SocketContext'
import { useHideMenu } from '../../hooks/useHideMenu'
import { useGetPantallas } from '../../hooks/useGetPantallas'
import { getUsuarioStorage } from '../../helpers/getUsuarioStorage'


import LoadingOverlay from '../../components/LoadingOverlay'
import { NoAcceso } from '../../components/NoAcceso'
import { SelectElement } from '../../components/selectElement2'
import { SelectBuscable } from '../../components/SelectBuscable'
import TiposAtenHorarios from './TiposAtenHorarios'
import { serverApi } from '../../api'
import { CrearTipoAtencionModal } from './components/CrearTipoAtencionModal'


const MySwal = withReactContent(Swal);

const sweet = (title, html, icon) => { MySwal.fire({ title, html, icon, confirmButtonColor: 'var(--color-primario)', timer: 15000 }) }

const sweetConfirm = (title, html, icon) => {
    return MySwal.fire({
        title,
        html,
        icon,
        confirmButtonText: 'Ok',
        confirmButtonColor: 'var(--color-primario)',
        showCancelButton: true,
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar'
    })
}

const paginacionBtn = {
    width: 34, height: 34, borderRadius: 10, border: '1.5px solid #e2e8f0',
    background: '#ffffff', color: 'var(--color-primario-texto)', cursor: 'pointer', fontSize: 12,
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
}

const botonAccion = (bg, color) => ({
    width: 30, height: 30, borderRadius: 9, border: 'none',
    background: bg, color, cursor: 'pointer', fontSize: 12,
    display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
    transition: 'background .15s',
})

const chipStyle = {
    background: '#f1f5f9', color: '#475569', fontWeight: 700,
    padding: '5px 11px', borderRadius: 999, fontSize: 12,
    display: 'inline-flex', alignItems: 'center', gap: 5,
    whiteSpace: 'nowrap', lineHeight: 1.4,
};

const chipOk = { background: '#d1fae5', color: '#047857' };
const chipNo = { background: '#e2e8f0', color: '#64748b' };

export const TiposAtencionPage = () => {

    const { socket } = useContext(SocketContext);
    useHideMenu(false);

    const [query, setQuery] = useState({
        search: '',
        page: 1,
        limit: 10,
        sortBy: 'tipoAtencion',
        sortDir: 'asc',
        ideUbicacion: '',
        codigoUbicacion: '',
        nombreUbicacion: '',
    });

    let [usuario] = useState(getUsuarioStorage());
    const pantallas = useGetPantallas();

    const [showModal, setShowModal] = useState(false);
    const [showModalEditar, setShowModalEditar] = useState(false);
    const [tipoEditar, setTipoEditar] = useState(null);

    const navigate = useNavigate();
    useEffect(() => {
        if (usuario.uidUsuario === null) {
            navigate("/Ingreso")
        }
    }, [usuario.uidUsuario, navigate])



    const [isLoading, setIsLoading] = useState(false);
    const [iconos, setIconos] = useState([]);

    const [ubicaciones, setUbicaciones] = useState([]);

    // tabla
    const [data, setData] = useState([]);
    const [total, setTotal] = useState(0);
    const totalPages = Math.max(1, Math.ceil(total / query.limit));



    const [searchInput, setSearchInput] = useState('');


    const [showHorarios, setShowHorarios] = useState(false);
    const [horarios, setHorarios] = useState([]);
    const [selectedTipo, setSelectedTipo] = useState(null);

    /*********************horarios de atencion  */

    useEffect(() => {

        if (!socket) return;

        const handler = (lista) => {
            setHorarios(lista)

        };

        socket.on('lista-para-horario', handler);

        return () => {
            socket.off('lista-para-horario', handler);
        };

    }, [socket]);


    const handleOpenHorarios = async (uidTipoAtencion, nombre) => {
        setSelectedTipo({ uidTipoAtencion, nombre });

        const codigoEntidad = usuario.codigoEntidad;
        const codigoUbicacion = query.codigoUbicacion === "" ? usuario.codigoUbicacion : query.codigoUbicacion;
        if (!codigoEntidad || !codigoUbicacion) return;

        try {
            const resp = await serverApi.post(
                `/tipos-atencion/horarios-tipos-atencion`,
                {
                    codigoEntidad,
                    codigoUbicacion,
                    uidTipoAtencion
                }
            );

            const hr = resp.data.horarios
            setHorarios(hr);
            setShowHorarios(true);

        } catch (error) {
            console.error("Error al obtener horarios", error);
        }

    };

    const handleAddHorario = async (nuevo) => {



        const codigoEntidad = usuario.codigoEntidad;
        const codigoUbicacion = query.codigoUbicacion === "" ? usuario.codigoUbicacion : query.codigoUbicacion;
        const uidTipoAtencion = selectedTipo.uidTipoAtencion;
        if (!codigoEntidad || !codigoUbicacion || !uidTipoAtencion) return;

        try {
            await serverApi.post(
                `/tipos-atencion/horarios-agregar`,
                {
                    ...nuevo,
                    codigoEntidad,
                    codigoUbicacion,
                    uidTipoAtencion
                }
            );

        } catch (error) {
            console.error("Error al obtener horarios", error);
        }



    };

    const handleEditHorario = async (h) => {

        const codigoEntidad = usuario.codigoEntidad;
        const codigoUbicacion = query.codigoUbicacion === "" ? usuario.codigoUbicacion : query.codigoUbicacion;
        const uidTipoAtencion = selectedTipo.uidTipoAtencion;

        const ideAgenda = h.ideAgenda;
        if (!codigoEntidad || !codigoUbicacion) return;

        try {
            await serverApi.put(
                `/tipos-atencion/horarios-editar`,
                {
                    ...h,
                    codigoEntidad,
                    codigoUbicacion,
                    uidTipoAtencion,
                    ideAgenda
                }
            );



        } catch (error) {
            console.error("Error al obtener horarios", error);
        }

    };

    const handleDeleteHorario = async (ideAgenda) => {

        const codigoEntidad = usuario.codigoEntidad;
        const codigoUbicacion = query.codigoUbicacion === "" ? usuario.codigoUbicacion : query.codigoUbicacion;
        const uidTipoAtencion = selectedTipo.uidTipoAtencion;

        if (!codigoEntidad || !codigoUbicacion) return;

        try {
            await serverApi.post(
                `/tipos-atencion/horarios-eliminar`,
                {
                    codigoEntidad,
                    codigoUbicacion,
                    uidTipoAtencion,
                    ideAgenda
                }
            );



        } catch (error) {
            console.error("Error al obtener horarios", error);
        }

    };

    /*********************horarios de atencion  */

    useEffect(() => {

        const nombreIcono = (codigo) => {
            if (!codigo) return 'sin icono';
            const prefijos = /^(fa|fas|far|fab|fa-sharp|fa-solid|fa-regular|fa-brands|fa-solid-fa|fa-sharp-solid)$/i;
            return String(codigo)
                .split(/\s+/)
                .filter((p) => p && !prefijos.test(p))
                .map((p) => p.replace(/^fa-/, ''))
                .join(' ')
                .replace(/-/g, ' ');
        };

        async function fetchData() {

            try {
                const resp = await serverApi.get(`/tipos-atencion/select-iconos`);

                if (resp.data.iconos.length === 0) return;

                const opciones = resp.data.iconos
                    .map((item) => ({
                        value: item.codigoIcono,
                        nombre: nombreIcono(item.codigoIcono)
                    }))
                    .sort((a, b) => a.nombre.localeCompare(b.nombre));

                setIconos(opciones)


            } catch (error) {
                console.error("Error al obtener iconos", error);
            }

        }

        fetchData();


    }, [])

    //Select-ubicaciones
    useEffect(() => {

        const codigoEntidad = localStorage.getItem("codigoEntidad");

        if (!codigoEntidad) return;

        const fetch = async () => {
            try {

                const resp = await serverApi.post(`/ubicaciones/select-ubicaciones`, { codigoEntidad });

                const opciones = resp.data.data.map((item) => ({ value: item.ideUbicacion, label: item.nombreUbicacion.toUpperCase(), data: item.codigoUbicacion }))
                setUbicaciones(opciones);

                const ubicacionUsuario = opciones.find(
                    u => u.data === usuario.codigoUbicacion
                );



                if (ubicacionUsuario) {
                    setQuery(prev => ({
                        ...prev,
                        ideUbicacion: ubicacionUsuario.value,
                        codigoUbicacion: ubicacionUsuario.data,
                        nombreUbicacion: ubicacionUsuario.label
                    }));
                }

            } catch (error) {
                console.error("Error al obtener clases Modulos", error);
            } finally {

            }
        };

        fetch();

    }, [usuario])

    //Carga inicial de los tipos de atención
    const loadTiposAtenciones = useCallback(async () => {

        const codigoEntidad = usuario.codigoEntidad;
        if (!codigoEntidad) return;

        const codigoUbicacion = query.codigoUbicacion === "" ? usuario.codigoUbicacion : query.codigoUbicacion;
        if (!codigoUbicacion) return;

        try {

            setIsLoading(true);

            const resp = await serverApi.post(
                `/tipos-atencion/lista-tiposatencion`,
                {
                    ...query,
                    codigoEntidad,
                    codigoUbicacion,
                    sortedBy: query.sortBy,
                    sortDirection: query.sortDir
                }
            );

            setData(resp.data.listaTiposAtencion || []);
            setTotal(resp.data.total || 0);

        } catch (error) {
            console.error("Error al obtener tipos de atención", error);
        } finally {
            setIsLoading(false);
        }

    }, [query, usuario])

    useEffect(() => {
        loadTiposAtenciones();
    }, [loadTiposAtenciones]);

    useEffect(() => {

        if (!socket) return;

        const handler = (lista) => {
            // Solo aplica el evento si corresponde a la sede visible en pantalla,
            // de lo contrario podría pisar la tabla con datos de otra sede.
            if (lista?.codigoUbicacion && query.codigoUbicacion && lista.codigoUbicacion !== query.codigoUbicacion) return;

            setData(Array.isArray(lista?.listaTiposAtencion) ? lista.listaTiposAtencion : []);
            setTotal(lista?.total || 0);
        };

        socket.on('lista-tiposatencion', handler);

        return () => {
            socket.off('lista-tiposatencion', handler);
        };

    }, [socket, query.codigoUbicacion]);



    useEffect(() => {
        const timeout = setTimeout(() => {

            if (searchInput.trim().length > 0 && searchInput.trim().length < 2) return;

            setQuery(prev => {
                if (prev.search === searchInput) return prev; // 🔥 evita re-render

                return {
                    ...prev,
                    search: searchInput,
                    page: 1
                };
            });

        }, 800);

        return () => clearTimeout(timeout);

    }, [searchInput]);


    const paginate = (page) => {
        if (page < 1 || page > totalPages) return;

        setQuery(prev => ({
            ...prev,
            page
        }));
    };

    const handleSortChange = (e) => {
        const [sortBy, sortDir] = e.target.value.split(':');
        setQuery(prev => ({ ...prev, sortBy, sortDir }));
    };


    const reiniciarConsecutivos = async () => {

        const codigoEntidad = usuario.codigoEntidad;
        const codigoUbicacion = query.codigoUbicacion === "" ? usuario.codigoUbicacion : query.codigoUbicacion;
        if (!codigoEntidad || codigoEntidad === null || !codigoUbicacion || codigoUbicacion === null) return sweet('Atención!', 'Revise la infromación', 'error');

        const confirmacion = await sweetConfirm("Atención", "Esta seguro de reiniciar la numeración?", "warning")
            .then((result) => {
                return (result);
            })
        if (!confirmacion.value) return false;

        try {
            setIsLoading(true);

            await serverApi.post(
                `/tipos-atencion/reinicia-tiposatencion`,
                {
                    ...query,
                    codigoEntidad,
                    codigoUbicacion,

                }
            );

            loadTiposAtenciones();

        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }


    }

    const inactivaTipoAtencion = async (uidTipoAtencion, accion) => {

        const codigoEntidad = usuario.codigoEntidad;
        const codigoUbicacion = query.codigoUbicacion === "" ? usuario.codigoUbicacion : query.codigoUbicacion;
        if (!codigoEntidad || codigoEntidad === null || !codigoUbicacion || codigoUbicacion === null) return sweet('Atención!', 'Revise la infromación', 'error');

        const act = accion === 1 ? "Activar" : "Inactivar";

        const confirmacion = await sweetConfirm("Atención", `Esta seguro de ${act} el registro?`, "warning").then((result) => {
            return (result);
        })

        if (!confirmacion.value) return false;

        try {
            setIsLoading(true);

            await serverApi.post(
                `/tipos-atencion/inactiva-tipoatencion`,
                {
                    ...query,
                    uidTipoAtencion,
                    accion,
                    codigoEntidad,
                    codigoUbicacion,
                }
            );

            loadTiposAtenciones();

        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }


    }

    const registraTipoAtencion = async (info) => {

        const codigoEntidad = usuario.codigoEntidad;
        if (!codigoEntidad || codigoEntidad === null) return sweet('Atención!', 'Revise la infromación', 'error');


        try {

            setIsLoading(true);
            const res = await serverApi.post(
                `/tipos-atencion/registra-tipoatencion`,
                {
                    ...info,
                    codigoEntidad,
                }
            );

            if (res.data.ok === false) {
                sweet('', res.data.resp, 'error');
            } else {
                sweet('', res.data.resp, 'success');
                setShowModal(false);
                loadTiposAtenciones();
            }




        } catch (error) {
            // sweet('Atención!', res[1], 'error');
            console.error(error);
        } finally {
            setIsLoading(false);

        }



    }

    const handleSelectUbicacion = (selected) => {
        setQuery(prev => ({
            ...prev,
            page: 1,
            ideUbicacion: selected.value,
            nombreUbicacion: selected.label,
            codigoUbicacion: selected.data
        }));
    };

    const abrirEditar = (item) => {

        setTipoEditar({
            ...item,
            chkPrioritario: item.indPrioridad === 1,
            chkPermiteTraslado: item.permiteTraslado === 1
        });

        setShowModalEditar(true);
    };

    const guardarEdicion = async (datos) => {

        const codigoEntidad = usuario.codigoEntidad;

        const codigoUbicacion = query.codigoUbicacion === "" ? usuario.codigoUbicacion : query.codigoUbicacion;

        try {

            setIsLoading(true);

            const res = await serverApi.post(
                `/tipos-atencion/actualizar-tipoatencion`,
                {
                    ...datos,
                    codigoEntidad,
                    codigoUbicacion,
                    uidTipoAtencion: datos.uidTipoAtencion
                }
            );

            if (res.data.ok === false) {
                sweet('', res.data.resp, 'error');
                return;
            }

            sweet(
                'Correcto',
                'Tipo de atención actualizado',
                'success'
            );

            setShowModalEditar(false);
            loadTiposAtenciones();

        } catch (error) {

            console.error(error);

            sweet(
                'Error',
                'No fue posible actualizar',
                'error'
            );

        } finally {

            setIsLoading(false);

        }
    };

    const sedeSeleccionada = ubicaciones.find(u => u.value === query.ideUbicacion);
    const nombreSede = (query.nombreUbicacion || sedeSeleccionada?.label || '').toUpperCase();


    if (usuario.uidUsuario === null) {
        return (<></>)
    }
    else if (!pantallas.includes("tiposatencion")) {
        return (<NoAcceso />)
    } else {
        return (
            <>
                {isLoading && <LoadingOverlay />}
                <div className={`content ${isLoading ? 'opacity' : ''}`} style={{ padding: '0 24px 24px', fontFamily: "'Inter', Arial, sans-serif" }}>

                    <div style={{ maxWidth: 1320, margin: '0 auto' }}>

                        <div style={{
                            background: 'white', borderRadius: 16, overflow: 'hidden',
                            boxShadow: '0 4px 20px rgba(0,0,0,0.06)', border: '1px solid #e2e8f0',
                        }}>

                            {/* Header de la card */}
                            <div style={{
                                padding: '20px 26px', background: '#f8fafc', borderBottom: '1px solid #e2e8f0',
                                display: 'flex', flexWrap: 'wrap', gap: 14, justifyContent: 'space-between', alignItems: 'center',
                            }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                                    <div style={{
                                        width: 46, height: 46, borderRadius: 14,
                                        background: 'linear-gradient(135deg, var(--color-primario) 0%, var(--color-secundario) 100%)',
                                        color: 'var(--color-marca-contraste)', display: 'flex', alignItems: 'center', justifyContent: 'center',
                                        fontSize: 20, boxShadow: '0 4px 14px rgba(var(--color-primario-rgb),0.3)',
                                    }}>
                                        <i className="fa-solid fa-list-check"></i>
                                    </div>
                                    <div>
                                        <h4 style={{ margin: 0, fontWeight: 800, fontSize: 18, color: '#0f172a' }}>Tipos de Atención</h4>
                                        <p style={{ margin: '2px 0 0', fontSize: 12.5, color: '#64748b' }}>
                                            Administra los tipos de atención por sede / ubicación
                                        </p>
                                    </div>
                                </div>

                                <div style={{ display: 'flex', alignItems: 'center', gap: 10, flexWrap: 'wrap' }}>
                                    <span style={{
                                        background: '#ecfdf5',
                                        color: '#047857',
                                        fontWeight: 800, padding: '6px 14px', borderRadius: 12, fontSize: 13,
                                        display: 'inline-flex', alignItems: 'center', gap: 7,
                                    }}>
                                        <i className="fa-solid fa-location-dot"></i>
                                        {nombreSede || 'Sede no definida'}
                                    </span>

                                    <button
                                        onClick={() => reiniciarConsecutivos()}
                                        title="Reiniciar la numeración de consecutivos de la sede seleccionada"
                                        style={{
                                            padding: '11px 18px', borderRadius: 12, border: '1.5px solid #fecaca',
                                            background: '#fff1f2', color: '#b91c1c', fontWeight: 800, cursor: 'pointer', fontSize: 13.5,
                                            display: 'inline-flex', alignItems: 'center', gap: 8,
                                        }}
                                    >
                                        <i className="fa-solid fa-rotate-left"></i> Reiniciar consecutivos
                                    </button>

                                    <button
                                        onClick={() => setShowModal(true)}
                                        style={{
                                            padding: '11px 20px', borderRadius: 12, border: 'none',
                                            background: 'linear-gradient(135deg, var(--color-primario) 0%, var(--color-secundario) 100%)',
                                            color: 'var(--color-marca-contraste)', fontWeight: 800, cursor: 'pointer', fontSize: 13.5,
                                            boxShadow: '0 4px 14px rgba(var(--color-primario-rgb),0.3)',
                                            display: 'inline-flex', alignItems: 'center', gap: 8,
                                        }}
                                    >
                                        <i className="fa-solid fa-plus"></i> Agregar Tipo de Atención
                                    </button>
                                </div>
                            </div>

                            {/* Barra de herramientas */}
                            <div style={{
                                padding: '16px 26px', borderBottom: '1px solid #f1f5f9',
                                display: 'flex', flexWrap: 'wrap', gap: 14, alignItems: 'flex-end', justifyContent: 'space-between',
                            }}>
                                <div style={{ position: 'relative', flex: 1, maxWidth: 420, minWidth: 220 }}>
                                    <i className="fa-solid fa-magnifying-glass" style={{
                                        position: 'absolute', left: 13, top: '50%', transform: 'translateY(-50%)',
                                        color: '#94a3b8', fontSize: 13,
                                    }} />
                                    <input
                                        type='text'
                                        placeholder='Buscar por tipo de atención...'
                                        maxLength={20}
                                        value={searchInput}
                                        onChange={(ev) => setSearchInput(ev.target.value)}
                                        style={{
                                            width: '100%', padding: '10px 12px 10px 38px', borderRadius: 10,
                                            border: '1.5px solid #e2e8f0', fontSize: 13.5, outline: 'none',
                                            background: '#f8fafc', transition: 'border-color .15s, background .15s',
                                        }}
                                        onFocus={(e) => { e.target.style.borderColor = 'var(--color-primario)'; e.target.style.background = '#ffffff'; }}
                                        onBlur={(e) => { e.target.style.borderColor = '#e2e8f0'; e.target.style.background = '#f8fafc'; }}
                                    />
                                </div>

                                <div style={{ width: 320, maxWidth: '100%' }}>
                                    <label style={{ fontSize: 12, fontWeight: 700, color: '#475569', display: 'block', marginBottom: 6 }}>
                                        Sede / Ubicación
                                    </label>
                                    <SelectElement
                                        options={ubicaciones}
                                        name={`idUbicacion`}
                                        isMulti={false}
                                        closeOnMenuSelect={true}
                                        value={ubicaciones.find(u => u.value === query.ideUbicacion)}
                                        onChange={(selected) => handleSelectUbicacion(selected)}
                                        classname=""
                                        isClearable={false}
                                        fontSize="13.5px"
                                    />
                                </div>

                                <div style={{ width: 210, maxWidth: '100%' }}>
                                    <label style={{ fontSize: 12, fontWeight: 700, color: '#475569', display: 'block', marginBottom: 6 }}>
                                        Ordenar por
                                    </label>
                                    <SelectBuscable
                                        name="sort"
                                        asEvent
                                        onChange={handleSortChange}
                                        isClearable={false}
                                        options={[
                                            { value: 'tipoAtencion:asc', label: 'Tipo (A–Z)' },
                                            { value: 'tipoAtencion:desc', label: 'Tipo (Z–A)' },
                                        ]}
                                        value={`${query.sortBy}:${query.sortDir}`}
                                        fontSize="13.5px"
                                    />
                                </div>
                            </div>

                            {/* Lista de tipos de atención */}
                            <div style={{ padding: '18px 26px', background: '#f8fafc' }}>
                                {data.length === 0 ? (
                                    <div style={{ padding: '48px 20px', textAlign: 'center' }}>
                                        <div style={{ color: '#94a3b8', fontSize: 34, marginBottom: 8 }}>
                                            <i className="fa-solid fa-list-check"></i>
                                        </div>
                                        <div style={{ fontWeight: 700, color: '#64748b', fontSize: 15 }}>
                                            No hay tipos de atención registrados
                                        </div>
                                        <div style={{ color: '#94a3b8', fontSize: 13, marginTop: 4 }}>
                                            Crea el primer tipo de atención para esta sede.
                                        </div>
                                    </div>
                                ) : (
                                    data.map((item) => {
                                        const activo = item.indActivo === 1;
                                        const colorItem = item.color || 'var(--color-primario)';
                                        return (
                                            <div
                                                key={item.uidTipoAtencion}
                                                style={{
                                                    background: '#ffffff', borderRadius: 14,
                                                    border: `1.5px solid ${activo ? '#e2e8f0' : '#fecaca'}`,
                                                    boxShadow: '0 1px 3px rgba(0,0,0,0.05)', padding: '16px 18px', marginBottom: 12,
                                                    display: 'flex', flexWrap: 'wrap', gap: 14,
                                                    alignItems: 'center', justifyContent: 'space-between',
                                                    opacity: activo ? 1 : 0.72,
                                                    transition: 'box-shadow .15s, border-color .15s',
                                                }}
                                                onMouseEnter={(e) => { e.currentTarget.style.boxShadow = '0 6px 16px rgba(var(--color-primario-rgb),0.12)'; e.currentTarget.style.borderColor = 'var(--color-primario)'; }}
                                                onMouseLeave={(e) => { e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.05)'; e.currentTarget.style.borderColor = activo ? '#e2e8f0' : '#fecaca'; }}
                                            >
                                                {/* Icono + nombre */}
                                                <div style={{ display: 'flex', alignItems: 'center', gap: 12, minWidth: 220, flex: '1 1 260px' }}>
                                                    <div style={{
                                                        width: 46, height: 46, borderRadius: 12, flexShrink: 0,
                                                        background: activo ? `${colorItem}1f` : '#f1f5f9',
                                                        border: '1.5px solid #e2e8f0',
                                                        color: activo ? colorItem : '#94a3b8',
                                                        display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 20,
                                                    }}>
                                                        <i className={item.icono}></i>
                                                    </div>
                                                    <div style={{ minWidth: 0 }}>
                                                        <div style={{ fontWeight: 800, color: '#0f172a', fontSize: 14.5, display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
                                                            {item.tipoAtencion}
                                                            {item.sigla && (
                                                                <span style={{
                                                                    background: '#e2e8f0', color: '#334155', fontWeight: 800,
                                                                    padding: '2px 9px', borderRadius: 999, fontSize: 11,
                                                                }}>
                                                                    {item.sigla}
                                                                </span>
                                                            )}
                                                            {!activo && (
                                                                <span className="badge" style={{ background: '#fee2e2', color: '#b91c1c', fontWeight: 800, padding: '4px 10px', borderRadius: 999, fontSize: 11 }}>
                                                                    INACTIVO
                                                                </span>
                                                            )}
                                                        </div>
                                                        <div style={{ color: '#64748b', fontSize: 12.5, marginTop: 2, textOverflow: 'ellipsis', whiteSpace: 'nowrap', overflow: 'hidden', maxWidth: 320 }}>
                                                            {item.complemento || 'Sin complemento'}
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Chips de información */}
                                                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 8, alignItems: 'center', flex: '1 1 400px' }}>
                                                    <span style={chipStyle}>
                                                        Orden: <b style={{ color: '#0f172a' }}>{item.orden}</b>
                                                    </span>
                                                    <span style={chipStyle}>
                                                        Ident: <b style={{ color: '#0f172a' }}>{item.codigoTipoAtencion}</b>
                                                    </span>
                                                    <span style={item.indPrioridad === 1 ? { ...chipStyle, ...chipOk } : { ...chipStyle, ...chipNo }}>
                                                        {item.indPrioridad === 1 ? <i className="fa-solid fa-star"></i> : null}
                                                        Prioridad: {item.indPrioridad === 1 ? 'Sí' : 'No'}
                                                    </span>
                                                    <span style={chipStyle}>
                                                        Atn. Prior: <b style={{ color: '#0f172a' }}>{item.prioritario}</b>
                                                    </span>
                                                    <span style={chipStyle}>
                                                        Atn. Corr: <b style={{ color: '#0f172a' }}>{item.cantidad}</b>
                                                    </span>
                                                    <span style={{
                                                        background: 'linear-gradient(135deg, var(--color-primario) 0%, var(--color-secundario) 100%)',
                                                        color: 'var(--color-marca-contraste)', fontWeight: 800,
                                                        padding: '5px 12px', borderRadius: 999, fontSize: 12.5,
                                                        display: 'inline-flex', alignItems: 'center', gap: 6,
                                                        boxShadow: '0 2px 8px rgba(var(--color-primario-rgb),0.35)',
                                                        whiteSpace: 'nowrap',
                                                    }}>
                                                        <i className="fa-solid fa-hashtag"></i> Consec: <b style={{ fontSize: 14 }}>{item.consecutivo}</b>
                                                    </span>
                                                    <span style={item.permiteTraslado === 1 ? { ...chipStyle, ...chipOk } : { ...chipStyle, ...chipNo }}>
                                                        {item.permiteTraslado === 1 ? <i className="fa-solid fa-check"></i> : null}
                                                        Traslado: {item.permiteTraslado === 1 ? 'Sí' : 'No'}
                                                    </span>
                                                    <span style={chipStyle}>
                                                        <span style={{
                                                            width: 14, height: 14, borderRadius: 4, display: 'inline-block',
                                                            backgroundColor: item.color || '#000000', border: '1.5px solid #e2e8f0',
                                                        }} />
                                                    </span>
                                                </div>

                                                {/* Acciones */}
                                                <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                                                    <button
                                                        title="Horarios de atención"
                                                        style={botonAccion('#fef3c7', '#92400e')}
                                                        onClick={() => handleOpenHorarios(item.uidTipoAtencion, item.tipoAtencion)}
                                                    >
                                                        <i className="fa-solid fa-clock"></i>
                                                    </button>
                                                    <button
                                                        title="Editar"
                                                        style={botonAccion('var(--color-secundario-suave)', 'var(--color-primario)')}
                                                        onClick={() => abrirEditar(item)}
                                                    >
                                                        <i className="fa-solid fa-pen"></i>
                                                    </button>
                                                    {activo ? (
                                                        <button
                                                            title="Inactivar"
                                                            style={botonAccion('#fee2e2', '#b91c1c')}
                                                            onClick={() => inactivaTipoAtencion(item.uidTipoAtencion, 0)}
                                                        >
                                                            <i className="fa-solid fa-ban"></i>
                                                        </button>
                                                    ) : (
                                                        <button
                                                            title="Activar"
                                                            style={botonAccion('#d1fae5', '#047857')}
                                                            onClick={() => inactivaTipoAtencion(item.uidTipoAtencion, 1)}
                                                        >
                                                            <i className="fa-solid fa-check"></i>
                                                        </button>
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    })
                                )}
                            </div>

                            {/* Paginación */}
                            <div style={{
                                padding: '14px 26px', borderTop: '1px solid #f1f5f9',
                                background: '#f8fafc', display: 'flex', flexWrap: 'wrap', gap: 10,
                                justifyContent: 'space-between', alignItems: 'center',
                            }}>
                                <span style={{ color: '#64748b', fontSize: 13 }}>
                                    Registros: <b style={{ color: '#0f172a' }}>{total}</b>
                                </span>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                                    <span style={{ fontSize: 13, color: '#475569' }}>
                                        Página {query.page} de {totalPages}
                                    </span>
                                    <button
                                        onClick={() => paginate(query.page - 1)}
                                        disabled={query.page === 1}
                                        style={{ ...paginacionBtn, opacity: query.page === 1 ? 0.4 : 1 }}
                                    >
                                        <i className="fa-solid fa-chevron-left"></i>
                                    </button>
                                    <button
                                        onClick={() => paginate(query.page + 1)}
                                        disabled={query.page >= totalPages}
                                        style={{ ...paginacionBtn, opacity: query.page >= totalPages ? 0.4 : 1 }}
                                    >
                                        <i className="fa-solid fa-chevron-right"></i>
                                    </button>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <TiposAtenHorarios
                    show={showHorarios}
                    onClose={() => setShowHorarios(false)}
                    tipoAtencion={selectedTipo}
                    horarios={horarios}
                    onAdd={handleAddHorario}
                    onEdit={handleEditHorario}
                    onDelete={handleDeleteHorario}
                />
                <CrearTipoAtencionModal
                    show={showModal}
                    onClose={() => setShowModal(false)}
                    iconos={iconos}
                    ubicaciones={ubicaciones}
                    onSave={(datos) => registraTipoAtencion(datos)}
                    modo="crear"

                />
                <CrearTipoAtencionModal
                    show={showModalEditar}
                    onClose={() => setShowModalEditar(false)}
                    onSave={guardarEdicion}
                    iconos={iconos}
                    ubicaciones={ubicaciones}
                    initialData={tipoEditar}
                    modo="editar"
                />
            </>
        )
    }
}